import GalleryResultPreview from './GalleryResultPreview';

export default function GalleryResults({ results }) {
	return (
		<div class="grid gap-4 sm:grid-cols-2 md:grid-cols-3 md:gap-6 lg:gap-8">
			{results?.map(result => <GalleryResultPreview item={result} />)}
		</div>
	);
}
